import styled from "styled-components";

export const Flex = styled.div<{ isBorder?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  border: ${({ isBorder }) => (isBorder ? "1px solid #ddd" : "none")};
  border-radius: 5px;
  padding: 10px;
`;
